define([
	"dojo/_base/declare",
	"csi/heading/Ref"
], function(declare, Ref) {

	return declare(Ref, {
		bCopy: true,

		/**
		 * @override
		 * Only allow copying if the size range is specified and for materials; we don't want it to
		 * be too easy to wipe out all sizes (similar to Styles). Also, check that the Material does
		 * not have owned sizes.
		 */
		canCopy: function(ctxCopy, h) {
			const parent = ctxCopy.getParent();

			if (!parent || parent.OwnedProductSizes.length) {
				return false;
			}

			const sizeRange = ctxCopy.getChildNode("ActualSizeRange");
			if (!sizeRange || !sizeRange.OKforMaterial) {
				return false;
			}

			return this.inherited(arguments);
		}
	});
});